<div
    provideParentForm
    class="telemetry-config"
    id="telemetry-config"
>
    <h6 class="full-modal__section-header">
        {{ l10nKeys.customerProgramLabel | vtranslate }}
    </h6>
    <avi-fieldset [hideContent]="true">
        <avi-fieldset_header class="telemetry-config__container">
            <div class="telemetry-config__telemetry-message-header">
                {{ globalL10nKeys.telemetryMessageHeaderText | vtranslate }}
            </div>
            <div
                class="telemetry-config__telemetry-message-body"
                [innerHTML]="globalL10nKeys.telemetryMessageBodyText | vtranslate: ceipUrl"
            ></div>
            <clr-checkbox-container>
                <clr-checkbox-wrapper>
                    <input
                        clrCheckbox
                        id="enable"
                        name="enable"
                        type="checkbox"
                        [(ngModel)]="telemetryConfig.enable"
                    />
                    <label
                        aviLabelWithTooltip
                        [objectType]="objectType"
                        fieldName="enable"
                        for="enable"
                    >
                        {{ globalL10nKeys.telemetryWelcomeInputLabel | vtranslate }}
                    </label>
                </clr-checkbox-wrapper>
            </clr-checkbox-container>
            <avi-input-container noMarginTop>
                <label
                    aviLabelWithTooltip
                    fieldName="url"
                    for="url"
                    [objectType]="objectType"
                    required
                >
                    {{ globalL10nKeys.urlInputLabel | vtranslate }}
                </label>
                <input
                    clrInput
                    id="url"
                    name="url"
                    type="text"
                    [placeholder]="l10nKeys.telemetryUrlPlaceholder | vtranslate"
                    [(ngModel)]="telemetryConfig.url"
                    required
                />
            </avi-input-container>
        </avi-fieldset_header>
    </avi-fieldset>
</div>
